// extracted by mini-css-extract-plugin
module.exports = {"AddVersionAction__add-version__be3vk":"AddVersionAction__add-version__be3vk","AddVersionAction__button__12gnN":"AddVersionAction__button__12gnN"};